var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9509 9.40796L8.23425 4.69962C8.15679 4.62152 8.06462 4.55952 7.96307 4.51721C7.86152 4.47491 7.7526 4.45312 7.64259 4.45312C7.53258 4.45312 7.42366 4.47491 7.32211 4.51721C7.22056 4.55952 7.12839 4.62152 7.05092 4.69962C6.89571 4.85576 6.80859 5.06697 6.80859 5.28712C6.80859 5.50728 6.89571 5.71849 7.05092 5.87462L11.1759 10.0413L7.05092 14.1663C6.89571 14.3224 6.80859 14.5336 6.80859 14.7538C6.80859 14.9739 6.89571 15.1852 7.05092 15.3413C7.1281 15.42 7.22014 15.4827 7.3217 15.5256C7.42326 15.5685 7.53233 15.5908 7.64259 15.5913C7.75284 15.5908 7.86191 15.5685 7.96348 15.5256C8.06504 15.4827 8.15708 15.42 8.23425 15.3413L12.9509 10.633C13.0355 10.5549 13.103 10.4602 13.1492 10.3548C13.1954 10.2494 13.2192 10.1355 13.2192 10.0205C13.2192 9.90538 13.1954 9.79153 13.1492 9.68612C13.103 9.5807 13.0355 9.48599 12.9509 9.40796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.9c665618d00d6dec74e972b43f25a37d.svg";
export { ForwardRef as ReactComponent };